import clsx from 'clsx';
import React__default, { useState } from 'react';

/* eslint-disable react/self-closing-comp */
const Toggle = ({ checked = false, disabled = false, small = false, onChange, ...inputProps }) => {
    const [checkedState, setCheckedState] = useState(checked);
    const handleChange = (event) => {
        const isChecked = event.target.checked;
        setCheckedState(isChecked);
        if (onChange) {
            onChange(event);
        }
    };
    const elemDisabled = disabled;
    return (React__default.createElement("label", { className: clsx('c-toggle', {
            'c-toggle--small': small
        }), ...(elemDisabled && { disabled: true }) },
        React__default.createElement("input", { ...inputProps, type: 'checkbox', checked: checkedState, disabled: disabled, onChange: handleChange }),
        React__default.createElement("span", { className: 'c-toggle__control' })));
};

export { Toggle };
//# sourceMappingURL=index.js.map
